import { useState } from 'react';

/**
 * Выполняет действие с подтверждением в два шага.
 *
 * Первый вызов взводит кнопку, второй запускает. Так случайный клик
 * не меняет чужие деньги и данные. Результат показывается на самой кнопке,
 * ошибка не прячется.
 */
export function useAction(run, { onDone, confirm = true } = {}) {
  const [state, setState] = useState('idle');
  const [error, setError] = useState(null);

  async function fire(...args) {
    if (confirm && state === 'idle') {
      setState('armed');
      setTimeout(() => setState((s) => (s === 'armed' ? 'idle' : s)), 4000);
      return;
    }
    setState('busy');
    setError(null);
    try {
      await run(...args);
      setState('done');
      if (onDone) onDone();
      setTimeout(() => setState('idle'), 2000);
    } catch (e) {
      setError(e);
      setState('idle');
    }
  }

  return { state, error, fire, reset: () => setState('idle') };
}
